export default __webpack_public_path__ + "static/media/laundry1-beforeA-1920w.8d76e901.avif";